import { useState } from "react";

export const useFormValidator = (initialValues, rules) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [fieldLoading, setFieldLoading] = useState({});

    const validateField = async (name, value) => {
        const validators = rules[name] || [];

        for (const rule of validators) {
            // A validator can be:
            //   1. An async function  → constructor.name === "AsyncFunction"
            //   2. A regular arrow fn that returns a Promise (e.g. wrapped async)
            // In both cases the result must be awaited. We detect a Promise by
            // checking instanceof so both cases are handled correctly.
            setFieldLoading(prev => ({ ...prev, [name]: true }));
            const raw = rule(value);
            const result = (raw instanceof Promise) ? await raw : raw;
            setFieldLoading(prev => ({ ...prev, [name]: false }));
            if (result !== true) return result;
        }
        return "";
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        const error = await validateField(name, value);
        setErrors((prev) => ({ ...prev, [name]: error }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setValues((prev) => ({ ...prev, [name]: value }));

        // reset error while typing
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
        if (name === "email") setErrors((prev) => ({ ...prev, confirmEmail: "" })); // reset confirm email mismatch
    };

    const validateAll = async () => {
        let temp = {};

        for (const key in values) {
            const error = await validateField(key, values[key]);
            if (error) temp[key] = error;
        }

        setErrors(temp);
        return Object.keys(temp).length === 0;
    };

    const handleSubmit = (id, callback) => async (e) => {
        e.preventDefault();
        setLoading(true);

        const valid = await validateAll();
        if (valid) callback(id, values);

        setLoading(false);
    };

    const handleClear = (id, callback) => async (e) => {
        e.preventDefault();
        setValues(initialValues);
        setErrors({});
        if (callback) callback(id);
    }

    return { values, errors, loading, fieldLoading, handleBlur, handleChange, handleSubmit, handleClear };
}
